import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

import {
  updateScheduleForm as onUpdate,
  updateTimeSlot as onTimeSlotUpdate,
  removeTimeSlot as onTimeSlotRemove,
  addTimeSlot as onTimeSlotAdd,
  setSchedule,
  resetScheduleForm,
} from '../../actions/scheduleForm';

import { updateSchedule } from '../../actions/events';

import Window from '../layout/Window';
import Button from '../layout/Button';
import Loading from '../layout/Loading';
import Form from '../forms/Schedule';

import './edit.scss';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.onSaveScheduleClick = this.onSaveScheduleClick.bind(this);
  }
  componentDidMount() {
    this.props.setSchedule(this.props.selectedSchedule);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedSchedule !== this.props.selectedSchedule) {
      this.props.setSchedule(this.props.selectedSchedule);
    }
  }

  componentWillUnmount() {
    this.props.resetScheduleForm();
  }

  onSaveScheduleClick() {
    const { match, location, history, organisationId, eventId, scheduleForm } = this.props;
    this.props.updateSchedule(eventId, scheduleForm.schedule).then(({ value }) => {
      history.push(`/organisations/${organisationId}/events/${eventId}/schedules/${value.id}${location.search}`)
    });
  }

  render() {
    const { t, organisationId, eventId, history, location, updateSchedule, scheduleForm, selectedSchedule, ...rest } = this.props

    return (
      <Window
        onCloseClick={() => history.push(`/organisations/${organisationId}/events/${eventId}/schedules${location.search}`)}
        title={`Schedule: ${selectedSchedule.description}`}
        footer={<Button onClick={() => updateSchedule(eventId, scheduleForm.schedule)}>{t('SAVE')}</Button>}>
          {scheduleForm.loading && <Loading />}
          <Form schedule={scheduleForm.schedule} { ...rest } />
          <Button className="save-edit-profile" onClick={this.onSaveScheduleClick}>{t('UPDATE_EVENT_SCHEDULE')}</Button>
      </Window>
    );
  }
}

export default translate('profile')(withRouter(connect(
  ( { ui: { scheduleForm }, events }, { match: { params: { organisationId, eventId, scheduleId } }, location, history }) => ({
    organisationId,
    eventId,
    location,
    history,
    scheduleId,
    scheduleForm: scheduleForm,
    selectedSchedule: events.data.find(e => e.id === eventId).schedules.find(s => s.id === scheduleId),
  }), {
    onUpdate,
    onTimeSlotUpdate,
    onTimeSlotRemove,
    onTimeSlotAdd,
    updateSchedule,
    setSchedule,
    resetScheduleForm,
  }
)(Edit)));



// WEBPACK FOOTER //
// ./src/components/schedules/Edit.js